import { Button } from "@nabble/ui";
import type { AdminDataRequest } from "../../../api/adminDataRequests";
import { isAnswered } from "../../../model/dataRequests";
import type { RequestDrawerState } from "./useRequestDrawer";

interface RequestDrawerActionsProps {
  request: AdminDataRequest;
  drawer: RequestDrawerState;
}

/** The drawer's footer buttons for the current mode; nothing once the request is answered. */
export function requestDrawerActions({ request: r, drawer }: RequestDrawerActionsProps): React.ReactNode {
  if (drawer.mode === "answer") {
    return (
      <>
        <Button label="Cancel" variant="secondary" onClick={() => drawer.startMode("view")} />
        <Button label="Send answer" icon="send" onClick={drawer.confirmAnswer} />
      </>
    );
  }
  if (drawer.mode === "extend") {
    return (
      <>
        <Button label="Cancel" variant="secondary" onClick={() => drawer.startMode("view")} />
        <Button label="Extend deadline" icon="clock" loading={drawer.busy} onClick={() => void drawer.extend()} />
      </>
    );
  }
  if (isAnswered(r.status)) return undefined;
  return (
    <>
      {r.extended ? null : <Button label="Extend deadline" variant="secondary" icon="clock" onClick={() => drawer.startMode("extend")} />}
      {r.status === "OPEN" ? <Button label="Mark in progress" variant="secondary" loading={drawer.busy} onClick={() => void drawer.markInProgress()} /> : null}
      <Button label="Answer" icon="send" onClick={() => drawer.startMode("answer")} />
    </>
  );
}
